export const WP_API_URL =
  process.env.REACT_APP_WP_API_URL || "https://api.caf-sports.com/wp-json";

/**
 * WooCommerce proxy — credentials stay on WordPress (never in browser Network tab).
 * Install wordpress/caf-wc-proxy.php on api.caf-sports.com
 */
export const WC_PROXY_BASE =
  process.env.REACT_APP_WC_PROXY_URL ||
  "https://api.caf-sports.com/wp-json/caf/v1/wc";

export const PRODUCTS_PER_PAGE = 6;

export const STORE_CURRENCY = process.env.REACT_APP_STORE_CURRENCY || "EGP";

/** Contact Form 7 — Caf-Mial form (numeric post ID) */
export const CF7_FORM_ID = process.env.REACT_APP_CF7_FORM_ID || "27";

/** CF7 unit tag for headless submissions — wpcf7-f{formId}-p{pageId}-o{occurrence} */
export const CF7_UNIT_TAG =
  process.env.REACT_APP_CF7_UNIT_TAG || `wpcf7-f${CF7_FORM_ID}-p1-o1`;

export function isWordPressConfigured() {
  return Boolean(WC_PROXY_BASE);
}
